import { useUserContext } from "@/components/user-context";

import { LoggedInConfluence } from "./logged-in/logged-in";
import { LoggedOutConfluence } from "./logged-out/logged-out";

export const ConfluenceSignup = () => {
    const {
        user: { isUserLoggedIn }
    } = useUserContext();

    if (isUserLoggedIn) {
        return <LoggedInConfluence />;
    }

    return <LoggedOutConfluence />;
};
